import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import mtekLogo  from "../../../assets/images/mtek-logo.svg"
import { useTranslation } from "react-i18next";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};



function BaggageAdditionalInformation({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [baggageAdditionalInfo, setBaggageAdditionalInfo] = useState({
    placeOfLoss: "",
    dateOfLoss: "",
    fullDetails: "",
    dateOfReportingToPolice: "",
    dateOfReportingToAirline: "",
    householdCountentsDetails: "",
    dateOfReportingToOperator: "",
  });

  const [isReportedToPolice, setIsReportedToPolice] = useState<boolean>(false);
  const [isReportedToAirline, setIsReportedToAirline] =
    useState<boolean>(false);
  const [isReportedToInsurance, setIsReportedToInsurance] =
    useState<boolean>(false);
  const [isReportedToOperator, setIsReportedToOperator] =
    useState<boolean>(false);

  useEffect(() => {
    setCurrentScreen("baggage-claim-additional");
    sessionStorage.setItem("claim-screens", "baggage-claim-additional");
  });

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setBaggageAdditionalInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const saveDetails = () => {
    if (!baggageAdditionalInfo.placeOfLoss) {
      document.getElementById("placeOfLoss")?.focus;
      toast.warning(t("baggageClaimAdd.enterPlaceOfLoss"));
      return;
    }
    if (!baggageAdditionalInfo.dateOfLoss) {
      document.getElementById("dateOfLoss")?.focus;
      toast.warning(t("baggageClaimAdd.enterDateOfLoss"));
      return;
    }
    if (!baggageAdditionalInfo.fullDetails) {
      document.getElementById("fullDetails")?.focus;
      toast.warn(t("baggageClaimAdd.enterFullDetails"));
      return;
    }
    if (isReportedToPolice) {
      if (!baggageAdditionalInfo.dateOfReportingToPolice) {
        document.getElementById("dateOfReportingToPolice")?.focus;
        toast.warn(t("baggageClaimAdd.enterPoliceReportDate"));
        return;
      }
    }
    if (isReportedToAirline) {
      if (!baggageAdditionalInfo.dateOfReportingToAirline) {
        document.getElementById("dateOfReportingToAirline")?.focus;
        toast.warn(t("baggageClaimAdd.enterAirlineReportDate"));
        return;
      }
    }
    if (isReportedToInsurance) {
      if (!baggageAdditionalInfo.householdCountentsDetails) {
        document.getElementById("householdCountentsDetails")?.focus;
        toast.warn(t("baggageClaimAdd.enterCoverDetails"));
        return;
      }
    }
    if (isReportedToOperator) {
      if (!baggageAdditionalInfo.dateOfReportingToOperator) {
        document.getElementById("dateOfReportingToOperator")?.focus;
        toast.warn(t("baggageClaimAdd.enterOperatorReportDate"));
        return;
      }
    }
    setCurrentScreen("claim-documents");
    sessionStorage.setItem("claims-back", "baggage-claim-additional");
    sessionStorage.setItem("claim-screens", "claim-documents");
    sessionStorage.setItem(
      "claimInfo",
      JSON.stringify(baggageAdditionalInfo)
    );
    sessionStorage.setItem("claim_type", "Baggage Claim")
  };
  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div
          className="image text-center mt-5 mb-3"
          onClick={() => navigate("/")}
        >
          <img src={mtekLogo} alt="travel icon" />
        </div>
        <div className="reg-title text-center mb-4">
          <span style={{ color: "#000000" }}>
            {t("baggageClaimAdd.additionalInfo")}
          </span>{" "}
          <span className="span-title">{t("baggageClaimAdd.baggageClaim")}</span>
        </div>
        <div className="cancellation-input">
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.placeOfLoss")}
                </label>
                <br />
                <div className="apartment-input" style={{ width: "100%" }}>
                  <input
                    id="placeOfLoss"
                    name="placeOfLoss"
                    type="text"
                    onChange={handleInputChange}
                    value={baggageAdditionalInfo.placeOfLoss}
                    placeholder={t("baggageClaimAdd.namePlaceholder")}
                  ></input>
                </div>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.dateOfLoss")}
                </label>
                <br />
                <div className="apartment-input" style={{ width: "100%" }}>
                  <input
                    id="dateOfLoss"
                    name="dateOfLoss"
                    type="date"
                    onChange={handleInputChange}
                    value={baggageAdditionalInfo.dateOfLoss}
                    placeholder={t("baggageClaimAdd.namePlaceholder")}
                  ></input>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="ky-input-wrapper" style={{ width: "100%" }}>
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label className="text-left-label mb-2" htmlFor="fullDetails">
                {t("baggageClaimAdd.fullDetailsCircumstances")}
              </label>
              <br />
              <input
                id="fullDetails"
                name="fullDetails"
                type="text"
                onChange={handleInputChange}
                value={baggageAdditionalInfo.fullDetails}
                placeholder={t("baggageClaimAdd.typeHere")}
              ></input>
            </motion.div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.reportedToPolice")}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isReportedToPolice
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setIsReportedToPolice(true)}
                  >
                    {t("baggageClaimAdd.yes")}
                  </button>
                  <button
                    className={
                      !isReportedToPolice
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setIsReportedToPolice(false)}
                  >
                    {t("baggageClaimAdd.no")}
                  </button>
                </div>
                {isReportedToPolice && (
                  <div className="apartment-input" style={{ width: "100%" }}>
                    <label htmlFor="" className="text-left-label mb-2">
                      {t("baggageClaimAdd.dateOfReporting")}
                    </label>
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                    >
                      {" "}
                      <input
                        id="dateOfReportingToPolice"
                        name="dateOfReportingToPolice"
                        type="date"
                        onChange={handleInputChange}
                        value={baggageAdditionalInfo.dateOfReportingToPolice}
                        placeholder={t("baggageClaimAdd.namePlaceholder")}
                      ></input>{" "}
                    </motion.div>
                  </div>
                )}
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.reportedToAirline")}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isReportedToAirline
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setIsReportedToAirline(true)}
                  >
                    {t("baggageClaimAdd.yes")}
                  </button>
                  <button
                    className={
                      !isReportedToAirline
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setIsReportedToAirline(false)}
                  >
                    {t("baggageClaimAdd.no")}
                  </button>
                </div>
                {isReportedToAirline && (
                  <div className="apartment-input" style={{ width: "100%" }}>
                    <label htmlFor="" className="text-left-label mb-2">
                      {t("baggageClaimAdd.dateOfReporting")}
                    </label>
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                    >
                      <input
                        id="dateOfReportingToAirline"
                        name="dateOfReportingToAirline"
                        type="date"
                        onChange={handleInputChange}
                        value={baggageAdditionalInfo.dateOfReportingToAirline}
                        placeholder={t("baggageClaimAdd.namePlaceholder")}
                      ></input>
                    </motion.div>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.coveredUnderHouseholdContents")}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isReportedToInsurance
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setIsReportedToInsurance(true)}
                  >
                    {t("baggageClaimAdd.yes")}
                  </button>
                  <button
                    className={
                      !isReportedToInsurance
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setIsReportedToInsurance(false)}
                  >
                    {t("baggageClaimAdd.no")}
                  </button>
                </div>
                {isReportedToInsurance && (
                  <div className="apartment-input" style={{ width: "100%" }}>
                    <label htmlFor="" className="text-left-label mb-2">
                      {t("baggageClaimAdd.provideCoverDetails")}
                    </label>
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                    >
                      {" "}
                      <input
                        id="householdCountentsDetails"
                        name="householdCountentsDetails"
                        type="text"
                        onChange={handleInputChange}
                        value={baggageAdditionalInfo.householdCountentsDetails}
                        placeholder={t("baggageClaimAdd.namePlaceholder")}
                      ></input>{" "}
                    </motion.div>
                  </div>
                )}
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("baggageClaimAdd.reportedToOperator")}
                </label>
                <br />
                <div className="countries d-flex mb-3">
                  <button
                    className={
                      isReportedToOperator
                        ? "countries-selection multiple-country baggage-button isOption-active"
                        : "countries-selection multiple-country baggage-button"
                    }
                    onClick={() => setIsReportedToOperator(true)}
                  >
                    {t("baggageClaimAdd.yes")}
                  </button>
                  <button
                    className={
                      !isReportedToOperator
                        ? "countries-selection one-country baggage-button isOption-active"
                        : "countries-selection one-country baggage-button"
                    }
                    onClick={() => setIsReportedToOperator(false)}
                  >
                    {t("baggageClaimAdd.no")}
                  </button>
                </div>
                {isReportedToOperator && (
                  <div className="apartment-input" style={{ width: "100%" }}>
                    <label htmlFor="" className="text-left-label mb-2">
                      {t("baggageClaimAdd.dateOfReporting")}
                    </label>
                    <motion.div
                      animate={{ scale: [-0.7, 1] }}
                      transition={{ duration: 1 }}
                    >
                      {" "}
                      <input
                        id="dateOfReportingToOperator"
                        name="dateOfReportingToOperator"
                        type="date"
                        onChange={handleInputChange}
                        value={baggageAdditionalInfo.dateOfReportingToOperator}
                        placeholder={t("baggageClaimAdd.namePlaceholder")}
                      ></input>
                    </motion.div>
                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="previous">
            <span
              onClick={(e) => {
                sessionStorage.setItem("claim-screens", "baggage-claim");
                setCurrentScreen("baggage-claim");
              }}
            >
              <span className="GrIcon me-2">
                <GrIcons.GrFormPreviousLink />
              </span>{" "}
              <span className="previous">{t("baggageClaimAdd.previous")}</span>
            </span>
          </div>
          <div className="mt-5" onClick={() => saveDetails()}>
            <button className="pointer-btn next-btn">
              {" "}
              <span>
                {t("baggageClaimAdd.proceed")}{" "}
                <span className="GrIcon ms-3">
                  <GrIcons.GrFormNextLink />
                </span>
              </span>{" "}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default BaggageAdditionalInformation;
